import React, { Component } from "react";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

class Header extends Component {
  render() {
    return (
      <Navbar bg="light" expand="lg">
        <div className="container">
          <Navbar.Brand href="#home">
            <div id="logo">
              <a className="logo" href="https://mesh.ai">
                <img
                  className="fixed-logo lazy loaded"
                  src="https://dgcb11b7ep7lw.cloudfront.net/wp-content/uploads/2020/10/mesh-A.png?x27725"
                  data-src="https://dgcb11b7ep7lw.cloudfront.net/wp-content/uploads/2020/10/mesh-A.png?x27725"
                  width="129"
                  alt="Mesh"
                />
              </a>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto"></Nav>
            <div style={{ display: "flex" }}>
              <Nav.Link href="/">Go Back to Resources</Nav.Link>
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>
    );
  }
}
export default Header;
